import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import Moment from 'react-moment';
import { IoIosRadioButtonOn,IoIosRefresh} from "react-icons/io";
import { FaFlag, FaRegFlag } from "react-icons/fa";
import { Container,Item,Navigation,Active,Itemnavigate ,Icon,Inactive,Col,FormContainer,Form,MesssageLogin,Name,BtnFlag,Hr,Textarea,Btnpreguntar} from './styles'

import globals from 'react-global-configuration';

export const ListOfQuestions = (props) => { 
    
    let valtotal =""
    const _URL_REST = globals.get('_URL_REST');
    
    const [messageLogin, setmessageLogin] = useState('Introduce tus datos para iniciar sesión');
    const [userData, setUserData] = useState(null);
    const [userPass, setUserPass] = useState(null);
    const [isadminlogin, setIsAdminLogin] = useState(null);
    const [idevento, setIdevento] = useState(-1);
    const [ideventoavisos, setIdeventoAvisos] = useState(-1);
    const [txtaviso, setTxtAviso] = useState(-1);
    const [settingsAviso, setSettingsAviso] = useState(false);
    const [question, setQuestion] = useState(null);
    const [ask, setAsk] = useState(null);
    
    const questionChange = (val) => {
        setQuestion(val.target.value)
    }

    const updateAsk = (val) => {
        if(val !== null){
            valtotal = val.replace(/\n/g, "<br />");
        }
        
    }

    const saveChange = async (val,idpregunta) => {
        const resultLog = await axios.post(`${_URL_REST}/saveask`, { val, idpregunta})
            console.log('RESULT::',resultLog)
            if(resultLog.status === 200){
                if(resultLog.data === 'error'){
                    //messageLoginChange('Se ha producido un error, intentelo más tardea')
                    //document.getElementById("isdivs").className = ''
                    //document.getElementById("divvolver").className = 'hide'
                }else{
                    document.getElementById('txtareaid-'+idpregunta).innerHTML = 'Respuesta: ' +val
                    fetchData()
                }
            }else{
                //messageLoginChange('Se ha producido un error, intentelo más tarde') 
                //document.getElementById("isdivs").className = ''
                //document.getElementById("divvolver").className = 'hide'
            }  
    }

    const responder = (val,txtrespuesta) => {

        valtotal = ''
        var list = document.getElementsByClassName("respuestaTextarea")
        for (var i = 0; i < list.length; i++) {
            list[i].remove()
        }
        var list = document.getElementsByClassName("botonTextarea")
        for (var i = 0; i < list.length; i++) {
            list[i].remove()
        }
        updateAsk(txtrespuesta)
        if(txtrespuesta != null){
            txtrespuesta = txtrespuesta.replace(/<br \/>/g,"\n")
        }
        var element = document.createElement("textarea")
        element.className = 'respuestaTextarea'
        element.name = 'message'
        element.cols = 30
        element.rows = 5
        element.value =  txtrespuesta
        element.onkeyup = function(){
            updateAsk(this.value)
          };
        var button = document.createElement('button')
        button.className = 'botonTextarea'
        button.innerHTML = "Guardar Respuesta"
        button.onclick = function(){
            saveChange(valtotal,val);return false;
          };
        document.getElementById('txtareaid-'+val).appendChild(element)
        document.getElementById('txtareaid-'+val).appendChild(button) 
        
    }
    

    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }
    const userChange = (val) => {
    setUserData(val.target.value)
    }
    const passChange = (val) => {
        setUserPass(val.target.value)
    }

    const fetchLogin = async () => {
       
        let hasErros = null
        if(userData === null){
            hasErros = true
            document.getElementById('nameLogin').classList.add('hasError');
        }else{
            document.getElementById('nameLogin').classList.remove('hasError');
        }
        
        if(userPass === null){
            hasErros = true
            document.getElementById('passLogin').classList.add('hasError');
        }else{
            document.getElementById('passLogin').classList.remove('hasError');
        }

        if(hasErros === null){ 
            
            const resultLogin = await axios(`${_URL_REST}/getsettings/${process.env.REACT_APP_EVENTO_ID}`)
            if(resultLogin.status === 200){
                if((resultLogin.data[0].moderator === userData) && (resultLogin.data[0].moderatorpass === userPass)){
                    sessionStorage.setItem('adminmoderacion','12wsd3456tgf')
                    setIsAdminLogin(true)
                }else{

                   
                        messageLoginChange('Nombre de usuario o contraseña incorrecta')
                   
                }
            }else{
                messageLoginChange('Se ha producido un error, intentelo más tarde') 
            }  
        }else{
            messageLoginChange('Rellena todos los campos para iniciar sesión')
        }
    };
    
    const [listSettings, setSettings] = useState(false);
    const [eventoslistado, seteventoslistado] = useState(false);
    
    const [showFlag, setShowFlag] = useState(true);

    const [data, setData] = useState({});

  
    const fetchSettings = async () => {
        const result = await axios(
            `${_URL_REST}/getsettings/${process.env.REACT_APP_EVENTO_ID}`,
        );
        setSettings(result.data[0])
    };
    const fetchData = async () => {
        const result = await axios(
            `${_URL_REST}/adminmoderacion/${idevento}`,
        );
        setData(result.data);
    };

    const fetchEventos = async () => {
        const result = await axios(
            `${_URL_REST}/eventosparamoderacion/${process.env.REACT_APP_EVENTO_ID}`,
        );
        seteventoslistado(result.data);
    };

    const activeModerate = async (val) => {
        //console.log('ACTIVAR',val)
        const result = await axios(
            `${_URL_REST}/activemoderacion/${val}`,
        );
        //console.log('activar::',result)
        fetchSettings();
    };
    const  changeEvent =  (e) => {
        console.log((e.target.value))
        setIdevento(e.target.value);
        
    };

    const updateAviso = (val) => {
        if(val.target.value !== null){
            setTxtAviso(val.target.value.replace(/\n/g, "<br />"))
        }
        
    }

    const changeEventAvisos = async (e) => {
        setSettingsAviso(false)
        console.log('e.target.value',e.target.value)
        setIdeventoAvisos(e.target.value);
        if(e.target == null){return}
        const result = await axios(
            `${_URL_REST}/getsettings/${e.target.value}`,
        );
        setSettingsAviso(result.data[0])
        console.log('AVISOS:',result.data[0])
        

        
        
    };

    const  enviarAviso = async () => {
        if(ideventoavisos === -1){
            alert('Seleccione un evento para enviar el aviso')
            return
        }
       
        let mostrar = 1
        const resultLog = await axios.post(`${_URL_REST}/saveaviso`, { txtaviso,mostrar, ideventoavisos})
            console.log('RESULT::',resultLog)
            if(resultLog.status === 200){
                if(resultLog.data === 'error'){
                    //messageLoginChange('Se ha producido un error, intentelo más tardea')
                    //document.getElementById("isdivs").className = ''
                    //document.getElementById("divvolver").className = 'hide'
                }else{
                    alert('El aviso se ha activado')
                }
            }


        const result = await axios(
            `${_URL_REST}/getsettings/${ideventoavisos}`,
        );
        setSettingsAviso(result.data[0])

        
    };

    const  ocultarAviso = async () => {
        if(ideventoavisos === -1){
            alert('Seleccione un evento')
            return
        }
       
        let mostrar = 0
        const resultLog = await axios.post(`${_URL_REST}/saveaviso`, { txtaviso,mostrar, ideventoavisos})
            console.log('RESULT::',resultLog)
            if(resultLog.status === 200){
                if(resultLog.data === 'error'){
                    //messageLoginChange('Se ha producido un error, intentelo más tardea')
                    //document.getElementById("isdivs").className = ''
                    //document.getElementById("divvolver").className = 'hide'
                }else{
                    alert('El aviso se ha desactivado')
                }
            }


        const result = await axios(
            `${_URL_REST}/getsettings/${ideventoavisos}`,
        );
        setSettingsAviso(result.data[0])

        
    };

    

    const fetchFlags = async () => {
        
        showFlag ? setShowFlag(false) : setShowFlag(true)
    };

    const updateFlag = async (val,id) => {
        //console.log('ACTIVAR',val)
        const result = await axios.post(
            `${_URL_REST}/updateflag/${val}/${id}`,
        );
        //console.log('activar::',result)
        fetchData();
    };

    useEffect(() => {
        fetchData();
    },[idevento]);
    useEffect(() => {
        fetchSettings();
    },[]);
    useEffect(() => {
        fetchEventos();
    },[])
    

    useEffect(() => {
        const interval = setInterval(() => {
          console.log('This will run every 30second!');
          console.log(idevento)
          fetchData();
        }, 30000);
        return () => clearInterval(interval);
      }, [idevento]);
  

    if (!data) {
        fetchData();
        return <div></div>  
    }
    if (!eventoslistado) {
        return <div></div>  
    }
    


 
    if(sessionStorage.getItem('adminmoderacion') !== null){
        isadminlogin !== true &&   setIsAdminLogin(true)
    }
      

    return (
        <Fragment>
            
            
        
            {isadminlogin? 
                
                <Container>

                    <h1>Mostrar avisos</h1>
                    <div>
                    
                    <select id="avisos" onChange={(e) => {changeEventAvisos(e)}} value={ideventoavisos}>
                        <option value="-1">Seleccione un evento</option>
                        {
                            eventoslistado.map(item => 
                            <option value={item.idEvento}>{item.cabeceraTitulo}</option>
                        )}
                        
                    </select>
                    </div>
                    { settingsAviso !== false  &&  settingsAviso !== undefined ? (
                    <div>
                        <div> 
                            {settingsAviso.mostrarAviso === 1 ? 
                                (<textarea name="textarea" rows="5" cols="60"  onChange={(e) => {updateAviso(e)}} >{settingsAviso.txtAviso}</textarea>)
                                :
                                (<textarea name="textarea2" rows="5" cols="60" onChange={(e) => {updateAviso(e)}} ></textarea>)
                            }         
                        </div>
                        <div>
                        {settingsAviso.mostrarAviso === 0 && (<Btnpreguntar onClick={(e) => {enviarAviso()}} >Mostrar Aviso</Btnpreguntar>) }

                        {settingsAviso.mostrarAviso === 1 && (<Btnpreguntar onClick={(e) => {ocultarAviso()}} >Ocultar Aviso</Btnpreguntar>) }
                        </div>
                    </div>
                    ):(<div></div>)}
                    <Hr />
                    <h1>Preguntas</h1>
                    <Navigation>
                    
                    <select id="lang" onChange={(e) => {changeEvent(e)}} value={idevento}>
                        <option value="-1">Seleccione un evento</option>
                        {
                            eventoslistado.map(item => 
                            <option value={item.idEvento}>{item.cabeceraTitulo}</option>
                        )}
                        
                     </select>
                        
                        { showFlag === true && <Itemnavigate>Mostrar marcados: <Active onClick={() => {fetchFlags()}}><IoIosRadioButtonOn /></Active></Itemnavigate> }
                        { showFlag === false && <Itemnavigate>Mostrar marcados: <Inactive onClick={() => {fetchFlags()}}><IoIosRadioButtonOn /></Inactive></Itemnavigate> }
                        <Itemnavigate>Actualizar: <Icon onClick={() => {fetchData()}}><IoIosRefresh /></Icon></Itemnavigate>
                    </Navigation>
                    {   Object.keys(data).length >= 1 ?
                        
                        showFlag ?
                        (
                            data
                            .map(item => 
                                <Item key={item.id} className={item.ask != null ? 'isask isflag-'+item.isNotice : 'isflag-'+item.isNotice} >
                                    <Name>
                                        <div>{item.user}</div>
                                        <BtnFlag>
                                            {
                                                item.isNotice ? ( <FaFlag onClick={() => {updateFlag(0,item.id)}} />) : ( <FaRegFlag  onClick={() => {updateFlag(1,item.id)}}/>) 
                                                
                                            }
                                        
                                        </BtnFlag>
                                    </Name>
                                    <div><Moment format="HH:mm:ss">{item.dateQ}</Moment></div>
                                    <div>{item.question}</div>
                                    <div>
                                        <Btnpreguntar onClick={() => {responder(item.id,item.ask)}} >Responder</Btnpreguntar>
                                    </div>
                                        { item.ask != null ? <div id={`txtareaid-${item.id}`}>Respuesta: <span dangerouslySetInnerHTML={{__html: item.ask}} /></div>  : <div id={`txtareaid-${item.id}`}></div> }
                                    <div>
                                    
                                    </div>

                                </Item>
                            )
                        )

                        :

                        (data
                            .filter(item => item.isNotice !== Number(1) )
                            .map(item => 
                                <Item key={item.id} className={'isflag-'+item.isNotice}>
                                    <Name>
                                        <div>{item.user}</div>
                                        <BtnFlag>
                                            {
                                                item.isNotice ? ( <FaFlag  onClick={() => {updateFlag(0,item.id)}} />) : ( <FaRegFlag  onClick={() => {updateFlag(1,item.id)}}/>) 
                                                
                                            }
                                           
                                        </BtnFlag>
                                    </Name>
                                    <div><Moment format="HH:mm:ss">{item.dateQ}</Moment></div>
                                    <div>{item.question}</div>
                                </Item>
                            )
                        )

                        
                        : <div>{idevento == '-1' ? <span>Seleccione un evento</span> : <span>No hay preguntas</span>}</div>
                    }
                    
                </Container>
                
            : 
                <Container>
                    <FormContainer>
                        <Form>
                            <MesssageLogin>{messageLogin}</MesssageLogin>
                            <input className="input-form" type="text" id="nameLogin" name="nameLogin" placeholder="Usuario (email)" onChange={ userChange } />
                            <input className="input-form" type="password" id="passLogin" name="passLogin" placeholder="Contraseña" onChange={passChange} />
                            <Col>
                                <button className="btn primary" type="button" onClick={fetchLogin}>Iniciar sesión</button>
                        
                            </Col>
                        </Form>
                    </FormContainer>
                </Container>    
        
            }

            
        </Fragment>
    )
}
